import { tsoPqTheme } from '@assets/style/customTsoPqtheme';

const background = tsoPqTheme.palette.background;
const stroke = tsoPqTheme.palette.stroke;
const error = tsoPqTheme.palette.customError;
const information = tsoPqTheme.palette.customInformation;

export const statusChipProps = {
  background: {
    error: error.color_signal_error_error_bg_dark,
    warning: information.color_signal_warning_warning,
    success: information.color_signal_success_success_bg_dark,
    inProgress: information.color_signal_information_information_bg_dark,
    onHold: stroke.color_neutral_stroke_str_ntrl_accent,
  },
  labelColor: {
    error: error.color_signal_error_error_bg_dark,
    warning: information.color_signal_warning_warning,
    success: information.color_signal_success_success_bg_dark,
    inProgress: information.color_signal_information_information_bg_dark,
    onHold: stroke.color_neutral_stroke_str_ntrl_accent,
  },
  hoverColor: {
    error: error.color_signal_error_error_bg_light,
    warning: information.color_signal_warning_warning_bg_light,
    success: information.color_signal_success_success_bg_light,
    inProgress: information.color_signal_information_information_bg_light,
    onHold: background.neutral.color_neutral_background_bg_neutral_lt,
  },
};
